<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="partner_wrap container">
      <div ref="partners">
        <titleConfig
          class="partner_h2"
          v-if="partnerData.mediaPartners.length > 0"
          :title="langSet == 'cn' ? '合作媒体' : 'Media Partners'"
          :type="2"
        ></titleConfig>
        <partner
          v-if="partnerData.mediaPartners.length > 0"
          :list="partnerData.mediaPartners"
        ></partner>
      </div>
      <div ref="sponsors">
        <titleConfig
          class="partner_h2"
          v-if="partnerData.supportUnit.length > 0"
          :title="langSet == 'cn' ? '支持单位' : 'Sponsors'"
          :type="2"
        ></titleConfig>
        <partner
          v-if="partnerData.supportUnit.length > 0"
          :list="partnerData.supportUnit"
        ></partner>
      </div>
      <div ref="exhibitions">
        <titleConfig
          class="partner_h2"
          v-if="partnerData.relateExhibitors.length > 0"
          :title="langSet == 'cn' ? '相关展会' : 'Other Related Exhibitions'"
          :type="2"
        ></titleConfig>
        <partner
          v-if="partnerData.relateExhibitors.length > 0"
          :list="partnerData.relateExhibitors"
        ></partner>
      </div>
      <div ref="brands">
        <titleConfig
          class="partner_h2"
          v-if="partnerData.brandExhibitors.length > 0"
          :title="langSet == 'cn' ? '品牌展商' : 'Exhibiting Brands'"
          :type="2"
        ></titleConfig>
        <partner
          v-if="partnerData.brandExhibitors.length > 0"
          :list="partnerData.brandExhibitors"
        ></partner>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import partner from "@/components/partner.vue";
import { getPartner } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    partner,
  },
  data() {
    return {
      langSet: "",
      type: "",
      partnerData: {
        mediaPartners: [],
        supportUnit: [],
        relateExhibitors: [],
        brandExhibitors: [],
      },
      metaData: {},
      id: "",
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    this.type = this.$route.query.type;
    //25.9.15 获取合作伙伴 dxm
    this.getpartnerData();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getpartnerData() {
      const res = await getPartner();
      if (this.type == 1) {
        this.partnerData.mediaPartners = [];
        this.partnerData.supportUnit = [];
        this.partnerData.relateExhibitors = [];
        this.partnerData.brandExhibitors = res.data.brandExhibitors;
      } else {
        this.partnerData = res.data;
      }
      this.id = this.$route.query.targetId;
      if (this.id) {
        this.$nextTick(() => {
          const target = this.$refs[this.id];
          if (target?.scrollIntoView) {
            const top = target.offsetTop - 120;
            window.scrollTo({
              top,
              behavior: "smooth",
            });
          } else {
            console.warn(
              "Target element not found or scrollIntoView not supported"
            );
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.partner_wrap {
  padding: 80px 0;
  min-height: 500px;
}
@media only screen and (max-width: 767px) {
  .partner_wrap {
    padding: 0.58rem 0;
  }
  .partner_list_wrap {
    margin: 0;
    background: #fff;
    padding-bottom: 0.5rem;
  }
}
</style>